import { render, staticRenderFns } from "./DisposeRemind.vue?vue&type=template&id=b2e73a9a&scoped=true"
import script from "./DisposeRemind.vue?vue&type=script&lang=js"
export * from "./DisposeRemind.vue?vue&type=script&lang=js"
import style0 from "./DisposeRemind.vue?vue&type=style&index=0&id=b2e73a9a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e73a9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2e73a9a')) {
      api.createRecord('b2e73a9a', component.options)
    } else {
      api.reload('b2e73a9a', component.options)
    }
    module.hot.accept("./DisposeRemind.vue?vue&type=template&id=b2e73a9a&scoped=true", function () {
      api.rerender('b2e73a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassOverviewDetail/components/RemindStuDetail/components/DisposeRemind.vue"
export default component.exports